import { useReducer } from "react";
import { RequestState } from "../../../constants/request-state";
import { SaveTransactionNoteModel } from "../../../types/note/Note";
import { transactionNotesService } from "../../../services/transaction-notes.service";
import { notesRequestActions, NotesRequestReducer } from "../state/notes-request-state";

export function useTransactionNoteSave(
    dealReferenceName: string,
    transactionReferenceName: string
) {
    const [requestState, dispatch] = useReducer(NotesRequestReducer, {})

    const noteSaveCallback = async (note: SaveTransactionNoteModel) => {
        dispatch(notesRequestActions.stateChanged(note.id ?? 0, RequestState.request));
        
        try {
            const noteResult = await transactionNotesService.saveNote(
                dealReferenceName, transactionReferenceName, note);
            dispatch(notesRequestActions.stateChanged(note.id ?? 0, RequestState.success));
            return noteResult;
        } catch (e) {
            dispatch(notesRequestActions.stateChanged(note.id ?? 0, RequestState.failure));
        }

        return null;
    }

    return { requestState, noteSaveCallback };
}